import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthPage from './components/auth/auth-page';
import ForgotPasswordPage from './components/auth/forgot-password';
import IframePage from './components/ui/iframe-page';

export default function AuthApp({ csrfToken }) {
    return (
        <Routes>
            <Route path='/login' element={<AuthPage page='login' csrfToken={csrfToken} />} />
            <Route path='/signup' element={<AuthPage page='signup' csrfToken={csrfToken} />} />
            <Route path='/signup/desktop' element={<AuthPage page='signup/desktop' csrfToken={csrfToken} />} />
            <Route path='/signup/heictojpg' element={<AuthPage page='signup/heictojpg' csrfToken={csrfToken} />} />
            <Route path='/forgot-password' element={<ForgotPasswordPage csrfToken={csrfToken} />} />

            <Route path='/privacy' element={<IframePage src='/static/privacy.html' />} />
            <Route path='/terms' element={<IframePage src='/static/terms.html' />} />

            <Route path='*' element={<Navigate to='/login' replace />} />
        </Routes>
    );
}
